import get from 'lodash.get';
import { createSelector } from 'src/universal/redux/utils';
import { getVacPageData } from 'page_modules/business-vac/redux/mainPageData';
import { getFilterContent } from 'src/universal/redux/cardsFilter';
import { hasPznDataArrived, getPznOfferList } from 'src/universal/redux/pznData';

export const gcsPrefix = 'gcsfilter-';

export const getFilterData = createSelector(
  [getFilterContent(true), getVacPageData],
  (bauFilterData, { pillboxVacFilter = {} }) => {
    const bauList = get(bauFilterData, 'filters.items') || [];
    const pillboxOrderList = get(pillboxVacFilter, 'order') || [];
    const sortedList = [];

    /*
    DE599846:  Why the next 8 lines?
    (1) recent iNav output produced an element with id value of "travel" which 
        caused the "Duplicate id attribute" a11y violation when jenkins runs the
        scanning.  This issue does not show up from local AxeTool scan.
    (2) we basically need to avoid this collision by changing the id values
        before sending the structure to the Aqx-Components library. 
    */
    const replicatedList = bauList.map(item => {
      const idVal = item.id;
      return {
        ...item,
        id: `${gcsPrefix}${idVal}`,
        internalId: idVal
      };
    });

    pillboxOrderList.forEach(item => {
      const targetItem = replicatedList.find(bauItem => bauItem.internalId === item);
      if (targetItem) {
        sortedList.push({ ...targetItem });
      }
    });

    return {
      ...(pillboxVacFilter || {}),
      sortedList
    };
  }
);

export const getFilterCardCountHash = createSelector(
  [getVacPageData, hasPznDataArrived, getPznOfferList],
  (pageData, pznArrived, offerList) => {
    const vacFilterContent = get(pageData, 'vacFilter.content') || [];
    const filterNameCntHash = vacFilterContent.reduce((accum, item) => {
      const nameList = Array.isArray(item?.cards) ? item?.cards : [];
      let cnt = nameList.length;
      if (pznArrived) {
        const filteredList = nameList.filter(
          sName => !!offerList.find(offer => offer.shortName === sName)
        );
        cnt = filteredList.length;
      }
      accum[item.filter] = cnt;
      return accum;
    }, {});

    return filterNameCntHash;
  }
);
